enum MarkerIcon {
  PIN = "pin",
  CIRCLE = "circle",
}

export default MarkerIcon;
